import { Alert02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { createContext, useContext, type ReactNode } from "react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  isSortField,
  sortFieldForArrayPath,
  sortOrderHintText,
} from "./array-sort";

const ArraySortPathContext = createContext<string | null>(null);

export function ArraySortPathProvider({
  arrayPath,
  children,
}: {
  arrayPath: string;
  children: ReactNode;
}) {
  return (
    <ArraySortPathContext.Provider value={arrayPath}>
      {children}
    </ArraySortPathContext.Provider>
  );
}

export function SortFieldMark({ fieldKey }: { fieldKey?: string }) {
  const arrayPath = useContext(ArraySortPathContext);
  if (!fieldKey || !arrayPath || !isSortField(arrayPath, fieldKey)) {
    return null;
  }
  return (
    <span className="text-[0.65rem] font-normal text-amber-700 dark:text-amber-400">
      排序
    </span>
  );
}

export function ItemOrderControls({
  disabled,
  index,
  total,
  arrayPath,
  onMove,
}: {
  disabled?: boolean;
  index: number;
  total: number;
  arrayPath: string;
  onMove: (delta: -1 | 1) => void;
}) {
  const sortField = sortFieldForArrayPath(arrayPath);
  const fieldLocked = Boolean(sortField);
  const hint = sortField ? sortOrderHintText(sortField) : null;
  return (
    <>
      {hint ? (
        <Tooltip>
          <TooltipTrigger
            type="button"
            className="inline-flex size-5 items-center justify-center rounded-sm text-amber-700 hover:bg-muted dark:text-amber-400"
            aria-label={hint}
          >
            <HugeiconsIcon
              icon={Alert02Icon}
              strokeWidth={2}
              className="size-3.5"
            />
          </TooltipTrigger>
          <TooltipContent>{hint}</TooltipContent>
        </Tooltip>
      ) : null}
      <Button
        type="button"
        size="icon-xs"
        variant="ghost"
        disabled={disabled || fieldLocked || index === 0}
        title={hint ?? "上移"}
        onClick={() => onMove(-1)}
      >
        ↑
      </Button>
      <Button
        type="button"
        size="icon-xs"
        variant="ghost"
        disabled={disabled || fieldLocked || index >= total - 1}
        title={hint ?? "下移"}
        onClick={() => onMove(1)}
      >
        ↓
      </Button>
    </>
  );
}
